import { render, staticRenderFns } from "./TypeText.vue?vue&type=template&id=aac4c44a&"
import script from "./TypeText.vue?vue&type=script&lang=js&"
export * from "./TypeText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports